import React, { useState, useEffect, useCallback, useRef } from "react";
import { Auth } from "aws-amplify";
import { useNavigate, useLocation } from "react-router-dom";
import { useLoading } from "../../../../context/LoadingContext";
import { jwtDecode } from "jwt-decode";
import config from "../../../../aws-exports";
import { getParameterFromManager } from "../../../../services/Utils";
import "../../../../styles/general.css";
import "../../../../styles/amtpl.css";
import SidebarCommon from "../../../../pages/Requirement/components/layout/AMTPLSidebar";
import Header from "../../../../pages/Requirement/components/layout/Header";
import DataTable from "../../../../pages/Requirement/components/common/ReusableTable";
import SearchFilter from "../../../../pages/Requirement/components/common/SearchFilter";
import dayjs from "dayjs";
import {
  TextField,
  Typography,
  Button,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";
import {
  fetchData,
  searchfetchQueries,
  postQuery,
} from "../../../../pages/Requirement/services/RequirementServices";
import { v4 as uuidv4 } from "uuid";
import AlertModal from "../../../../pages/Requirement/components/common/AlerModel";

const CountryWiseProduct = () => {
  const location = useLocation();
  const initialFilter =
    location.state?.selectedFilter || "Country wise Product";
  const [activeUser, setActiveUser] = useState("");
  const [selectedFilter, setSelectedFilter] = useState(initialFilter);
  const { setLoading } = useLoading();
  const [rowStart, setRowStart] = useState(0);
  const [pageSize] = useState(5);
  const [totalItems, setTotalItems] = useState(0);
  const [countrywiseProductDemand, setCountrywiseProductDemand] = useState([]);
  const navigate = useNavigate();
  const [INRToUsd, setINRToUSD] = useState(0.012);
  const [showForm, setShowForm] = useState(false);
  const [searchValues, setSearchValues] = useState({
    searchProduct: "",
    searchProductGrade:"",
    searchDestinationCountry: "",
    searchDestinationPort: "",
  });

  const [productList, setProductList] = useState([]);
  const [productGradeList, setProductGradeList] = useState([]);
  const [porList, setPortList] = useState([]);
  const [formPortList, setFormPortList] = useState([]);
  const [countrymaster, setCountryMaster] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editCountryWiseProductDemandID, setEditCountryWiseProductDemandID] =
    useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const [modal, setModal] = useState({
    show: false,
    type: "info",
    title: "",
    message: "",
    nextAction: null,
    autoClose: null,
  });

  const formRef = useRef(null);

  const handleModalClose = () => {
    const action = modal.nextAction;
    setModal((prev) => ({ ...prev, show: false, nextAction: null }));
    if (action) action();
  };

  // Form state
  const [formData, setFormData] = useState({
    product: "",
    destinationCountry: "",
    destinationPort: "",
    margin: "",
    exportDuty: "",
  });

  // State for errors
  const [errors, setErrors] = useState({});

  // Handle input change for the form
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Validate form
  const validateForm = () => {
    const newErrors = {};

    // Check required fields
    if (!formData.product) newErrors.product = "This field is required";
    if (!formData.destinationCountry)
      newErrors.destinationCountry = "This field is required";
    if (!formData.destinationPort)
      newErrors.destinationPort = "This field is required";
    if (!formData.margin) newErrors.margin = "This field is required";
    if (!formData.exportDuty) newErrors.exportDuty = "This field is required";

    // Check numeric fields for charges
    const chargesFields = ["margin", "exportDuty"];
    chargesFields.forEach((field) => {
      if (formData[field]) {
        const value = parseFloat(formData[field].trim());
        if (isNaN(value)) {
          newErrors[field] = "Must be a number";
        } else if (value < 0) {
          newErrors[field] = "Must be non-negative";
        } else if (value > 100) {
          newErrors[field] = "Must be less than or equal to 100";
        }
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Simulate API call to save form data
  const saveFormData = async (data) => {
    setLoading(true);
    try {
      // Simulate API call with a 1-second delay
      let body = null;
      console.log("Saving data to API:", data);
      if (isEditMode) {
        body = {
          target: "updateCountryWiseProductDemand",
          updateCountryWiseProductDemandInput: {
            CountryWiseProductDemandID: data.CountryWiseProductDemandID,
            ProductID: data.product,
            DestinationCountry: data.destinationCountry,
            DestinationPort: data.destinationPort,
            Margin: data.margin,
            ExportDuty: data.exportDuty,
          },
        };
      } else {
        body = {
          target: "createCountryWiseProductDemand",
          createCountryWiseProductDemandInput: {
            CountryWiseProductDemandID: data.CountryWiseProductDemandID,
            ProductID: data.product,
            DestinationCountry: data.destinationCountry,
            DestinationPort: data.destinationPort,
            Margin: data.margin,
            ExportDuty: data.exportDuty,
          },
        };
      }

      console.log("Saving body to API:", body);
      if (body !== null) {
        const result = await postQuery(body);
        if (result) {
          setModal({
            show: true,
            type: "success",
            title: "Success",
            message: `Countrywise product demand charges ${
              isEditMode ? "updated" : "added"
            } successfully!`,
            autoClose: 2000,
          });
        }
      }

      // Refresh the table data
      await searchCountryWiseProductDemand(searchValues, rowStart);
    } catch (error) {
      console.error("Error saving data:", error);
      setModal({
        show: true,
        type: "error",
        title: "Error",
        message: `Failed to ${
          isEditMode ? "update" : "add"
        } countrywise product demand charges.`,
      });
    } finally {
      setLoading(false);
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      const dataToSave = {
        ...formData,
        CountryWiseProductDemandID: isEditMode
          ? editCountryWiseProductDemandID
          : uuidv4(),
      };
      await saveFormData(dataToSave);
      setShowForm(false);
      setIsEditMode(false);
      setEditCountryWiseProductDemandID(null);
      setSelectedRow(null);
      setFormData({
        product: "",
        destinationCountry: "",
        destinationPort: "",
        margin: "",
        exportDuty: "",
      });
    } else {
      console.log("Validation failed");
    }
  };

  // Handle form reset
  const handleReset = () => {
    setFormData({
      product: "",
      destinationCountry: "",
      destinationPort: "",
      margin: "",
      exportDuty: "",
    });
    setErrors({});
    setIsEditMode(false);
    setEditCountryWiseProductDemandID(null);
    setSelectedRow(null);
    setShowForm(false);
    setFormPortList([]);
  };

  const handleDataFilterChange = useCallback(
    (event) => {
      const selectedValue = event.target.value;
      setSelectedFilter(selectedValue);
      console.log("Selected filter:", selectedValue);
      if (
        selectedValue === "products" ||
        selectedValue === "offers" ||
        selectedValue === "entities"
      ) {
        navigate("/amtpl", { state: { selectedFilter: selectedValue } });
        console.log(selectedValue);
      } else if (selectedValue === "Add Requirement") {
        navigate("/amtpl/addrequirement", {
          state: { selectedFilter: selectedValue },
        });
      } else if (selectedValue === "Requirement Approval") {
        navigate("/amtpl/requirement", {
          state: { selectedFilter: selectedValue },
        });
      } else if (selectedValue === "Product Offers") {
        navigate("/amtpl/productofferscharges", {
          state: { selectedFilter: selectedValue },
        });
      } else if (selectedValue === "Inland Shipping") {
        navigate("/amtpl/inlandshipping", {
          state: { selectedFilter: selectedValue },
        });
      } else if (selectedValue === "Country wise Product") {
        navigate("/amtpl/counrywiseproduct", {
          state: { selectedFilter: selectedValue },
        });
      } else if (selectedValue === "Product Category") {
        navigate("/amtpl/productcategory", {
          state: { selectedFilter: selectedValue },
        });
      } else if (selectedValue === "Product") {
        navigate("/amtpl/product", {
          state: { selectedFilter: selectedValue },
        });
      }
    },
    [navigate]
  );

  const loadProductList = useCallback(async () => {
    setLoading(true);
    try {
      const [initialResponse] = await Promise.all([
        fetchData({
          target: "listProducts",
          userOrder: "ProductName",
          rowStart: 0,
          pageSize: 1,
        }),
      ]);

      const totalCount = initialResponse?.total || initialResponse?.length || 0;

      if (totalCount > 0) {
        const [allProducts] = await Promise.all([
          searchfetchQueries({
            target: "listProducts",
            userOrder: "ProductName",
            rowStart: 0,
            pageSize: totalCount,
          }),
        ]);

        // Filter distinct ports based on DestinationPortAdd commentMore actions
        const distinctProducts = Array.from(
          new Map(allProducts.map((p) => [p.ProductName, p])).values()
        );
        console.log("@@distinctProducts", distinctProducts);

        setProductList(distinctProducts);
      } else {
        setProductList([]);
      }
    } catch (error) {
      console.error("Error loading products: ", error);
    } finally {
      setLoading(false);
    }
  }, [setLoading]);

  const loadProductGrades = useCallback(
    async (productName) => {
      setLoading(true);
      try {
        const [allGrades] = await Promise.all([
          fetchData({
            target: "listProducts",
            userOrder: "ProductName",
            rowStart: 0,
            pageSize: 500,
            filterTerms: { ProductName: productName },
          }),
        ]);
        if (allGrades.items.length > 0) {
          setProductGradeList(allGrades.items);
        } else {
          setProductGradeList([]);
        }
      } catch (error) {
        console.error("Error loading product grades: ", error);
      } finally {
        setLoading(false);
      }
    },
    [setLoading]
  );

  const loadPortList = useCallback(
    async (country) => {
      setLoading(true);
      try {
        const [allPorts] = await Promise.all([
          fetchData({
            target: "listDropDownOptions",
            userOrder: "Value",
            rowStart: 0,
            pageSize: 500,
            filterTerms: { Type: "port", Subtype: country },
          }),
        ]);
        if (allPorts.items.length > 0) {
          setPortList(allPorts.items);
        } else {
          setPortList([]);
        }
      } catch (error) {
        console.error("Error loading ports: ", error);
      } finally {
        setLoading(false);
      }
    },
    [setLoading]
  );

  const loadFormPorts = useCallback(
    async (country) => {
      setLoading(true);
      try {
        const [allPorts] = await Promise.all([
          fetchData({
            target: "listDropDownOptions",
            userOrder: "Value",
            rowStart: 0,
            pageSize: 500,
            filterTerms: { Type: "port", Subtype: country },
          }),
        ]);
        if (allPorts.items.length > 0) {
          setFormPortList(allPorts.items);
        } else {
          setFormPortList([]);
        }
      } catch (error) {
        console.error("Error loading ports: ", error);
      } finally {
        setLoading(false);
      }
    },
    [setLoading]
  );

  const loadCountries = useCallback(async () => {
    setLoading(true);
    try {
      const [allCountries] = await Promise.all([
        fetchData({
          target: "listDropDownOptions",
          userOrder: "Value",
          rowStart: 0,
          pageSize: 250,
          filterTerms: { Type: "Country" },
        }),
      ]);
      if (allCountries.items.length > 0) {
        setCountryMaster(allCountries.items);
      } else {
        setCountryMaster([]);
      }
    } catch (error) {
      console.error("Error loading countries: ", error);
    } finally {
      setLoading(false);
    }
  }, [setLoading]);

  const searchCountryWiseProductDemand = useCallback(
    async (searchValue, newRowStart = rowStart) => {
      setLoading(true);
      const body = {
        target: "listProductDemandDetails",
        userOrder: "ProductName",
        rowStart: newRowStart,
        pageSize: pageSize,
        filterTerms: {
          ProductNamePartial: searchValue.searchProduct,
          Grade: searchValue.searchProductGrade,
          DestinationCountry: searchValue.searchDestinationCountry,
          DestinationPort: searchValue.searchDestinationPort,
        },
      };
      try {
        const response = await fetchData(body);
        setCountrywiseProductDemand(response.items || response);
        setTotalItems(response.total || 0);
      } catch (error) {
        console.error("Error loading listProductDemandDetails: ", error);
        setCountrywiseProductDemand([]);
        setTotalItems(0);
      } finally {
        setLoading(false);
      }
    },
    []
  );

  const handleRowClick = useCallback(async (row) => {
    console.log("selected row::", row);
    setSelectedRow(row);
    setIsEditMode(true);
    setEditCountryWiseProductDemandID(row.CountryWiseProductDemandID);
    setShowForm(true);
  }, []);

  // Populate form data when selectedRow changes
  useEffect(() => {
    if (selectedRow && isEditMode) {
      if (selectedRow.DestinationCountry?.toString() !== "") {
        loadFormPorts(selectedRow.DestinationCountry?.toString());
      }
      setFormData({
        product: selectedRow.ProductID || "",
        destinationCountry: selectedRow.DestinationCountry?.toString() || "",
        destinationPort: selectedRow.DestinationPort?.toString() || "",
        margin: selectedRow.Margin?.toString() || "",
        exportDuty: selectedRow.ExportDuty?.toString() || "",
      });
    }
  }, [selectedRow, isEditMode]);

  // Scroll to form when showForm is true
  useEffect(() => {
    if (showForm && formRef.current) {
      formRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [showForm]);

  useEffect(() => {
    // console.log(selectedFilter);
    const checkUser = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;
        const decodedToken = jwtDecode(token);

        const groups = decodedToken["cognito:groups"] || [];
        if (!groups.includes("AMTPL_ADMINS")) {
          await Auth.signOut();
          navigate("/");
        } else {
          setActiveUser(user.attributes.email);
        }
        let inrToUsdVal = await getParameterFromManager("INR_TO_USD");
        inrToUsdVal = parseFloat(inrToUsdVal);
        setINRToUSD(inrToUsdVal);
      } catch (error) {
        await Auth.signOut();
        navigate("/");
      }
    };

    checkUser();
    loadProductList();
    loadCountries();
  }, [navigate]);

  useEffect(() => {
    searchCountryWiseProductDemand(searchValues);
  }, [loadProductList,searchValues]);

  const handlePageChange = (page) => {
    const newRowStart = (page - 1) * pageSize;
    setRowStart(newRowStart);
    searchCountryWiseProductDemand(searchValues, newRowStart);
  };

  const handleSearch = (searchTerm) => {
    console.log("Searching for:", searchTerm);
    searchCountryWiseProductDemand(searchTerm);
    setRowStart(0); // Reset to first page on new search
  };

  const currentPage = Math.floor(rowStart / pageSize) + 1;

  const fields = [
    {
      name: "searchProduct",
      label: "Product",
      type: "dropdown",
      options: productList.map((item) => ({
        value: item.ProductName,
        label: item.ProductName,
      })),
      value: searchValues.searchProduct,
      onChange: (value) => {
        setSearchValues((prev) => ({ ...prev, searchProduct: value }));
        loadProductGrades(value);
      },
    },
    {
      name: "searchProductGrade",
      label: "Product Grade",
      type: "dropdown",
      options: productGradeList.map((item) => ({
        value: item.Grade,
        label: item.Grade,
      })),
      value: searchValues.searchProductGrade,
      onChange: (value) => {
        setSearchValues((prev) => ({ ...prev, searchProductGrade: value }));
      },
    },
    {
      name: "searchDestinationCountry",
      label: "Destination Country",
      type: "dropdown",
      options: countrymaster.map((item) => ({
        value: item.Value,
        label: item.Value,
      })),
      value: searchValues.searchDestinationCountry,
      onChange: (value) => {
        setSearchValues((prev) => ({
          ...prev,
          searchDestinationCountry: value,
        }));
        loadPortList(value);
      },
    },
    {
      name: "searchDestinationPort",
      label: "Destination Port",
      type: "dropdown",
      options: porList.map((item) => ({
        value: item.Value,
        label: item.Value,
      })),
      value: searchValues.searchDestinationPort,
      onChange: (value) =>
        setSearchValues((prev) => ({ ...prev, searchDestinationPort: value })),
    },
  ];

  const columns = [
    {
      id: "ProductName",
      numeric: false,
      label: "Product",
      // renderCell: (row) => {
      //   const item = productList.find((p) => p.ProductID === row.ProductID);
      //   return item ? item.ProductName : "";
      // },
    },
    {
      id: "Grade",
      numeric: false,
      label: "Grade",
      // renderCell: (row) => {
      //   const item = productList.find((p) => p.ProductID === row.ProductID);
      //   return item ? item.Grade : "";
      // },
    },
    {
      id: "DestinationCountry",
      numeric: false,
      label: "Destination Country",
    },
    {
      id: "DestinationPort",
      numeric: false,
      label: "Destination Port",
    },
    {
      id: "Margin",
      numeric: true,
      label: "Margin (in %)",
    },

    { id: "ExportDuty", numeric: true, label: "Export Duty (in %)" },
  ];
  return (
    <div className="amtpl-dashboard">
      <AlertModal
        type={modal.type}
        title={modal.title}
        message={modal.message}
        showModal={modal.show}
        onClose={handleModalClose}
        buttonText="OK"
        autoClose={modal.autoClose}
      />
      <Header activeUser={activeUser} setLoading={setLoading} />

      <div className="content">
        <SidebarCommon
          selectedFilter={selectedFilter}
          handleDataFilterChange={handleDataFilterChange}
        />
        <main className="main-content">
          <div className="table-header">
            <div className="header-text">
              <div className="head-text">Country Wise Product Demand</div>
            </div>

            <div
              className="head-btn"
              style={{ display: "flex", gap: "10px", alignItems: "center" }}
            >
              <div
                className="submit-btn"
                onClick={() => {
                  setShowForm(!showForm);
                  setIsEditMode(false);
                  setFormData({
                    product: "",
                    destinationCountry: "",
                    destinationPort: "",
                    margin: "",
                    exportDuty: "",
                  });
                }}
              >
                Add
              </div>
            </div>
          </div>
          <div className="search-filter">
            <div className="row">
              <SearchFilter fields={fields} onSearch={handleSearch} />
            </div>
          </div>
          <div className="table-css">
            <DataTable
              columns={columns}
              data={countrywiseProductDemand}
              total={totalItems}
              title="Countrywise Product Demand Information"
              rowsPerPage={pageSize}
              onRowClick={handleRowClick}
              onPageChange={handlePageChange}
              currentPage={currentPage}
            />
          </div>
          {showForm && (
            <div className="box-main">
              <div className="table-header">
                <div className="header-text">
                  <div className="head-text">
                    {/* {isEditMode ? "Edit" : "Add"}  */}
                  </div>
                </div>
                <div className="head-btn">
                  <>
                    <div onClick={handleSubmit} className="submit-btn">
                      {isEditMode ? "Update" : "Submit"}
                    </div>
                    <div onClick={handleReset} className="submit-btn">
                      {isEditMode ? "Cancel" : "Reset"}
                    </div>
                  </>
                </div>
              </div>

              {/* Form Section */}

              <form
                ref={formRef}
                onSubmit={handleSubmit}
                style={{
                  padding: "10px",
                  backgroundColor: "#f9f9f9",
                  borderRadius: "8px",
                }}
              >
                <div className="row">
                  {/* Product Dropdown */}
                  <div className="col-md-4">
                    <FormControl
                      sx={{ minWidth: "100%" }}
                      error={!!errors.product}
                    >
                      <Typography variant="body2">Select Product</Typography>
                      <Select
                        name="product"
                        value={formData.product}
                        onChange={handleChange}
                        displayEmpty
                        sx={{ backgroundColor: "white" }}
                        inputProps={{ "aria-label": "Select Product" }}
                      >
                        <MenuItem value="" disabled>
                          Select Product
                        </MenuItem>
                        {productList.map((p) => (
                          <MenuItem key={p.ProductID} value={p.ProductID}>
                            {p.ProductName + " (" + p.Grade + ")"}
                          </MenuItem>
                        ))}
                      </Select>
                      {errors.product && (
                        <Typography variant="caption" color="error">
                          {errors.product}
                        </Typography>
                      )}
                    </FormControl>
                  </div>

                  {/* Destination Country */}
                  <div className="col-md-4">
                    <FormControl
                      sx={{ minWidth: "100%" }}
                      error={!!errors.destinationCountry}
                    >
                      <Typography variant="body2">
                        Select Destination Country
                      </Typography>
                      <Select
                        name="destinationCountry"
                        value={formData.destinationCountry}
                        onChange={(e) => {
                          handleChange(e);
                          loadFormPorts(e.target.value);
                        }}
                        displayEmpty
                        sx={{ backgroundColor: "white" }}
                        inputProps={{
                          "aria-label": "Select Destination Country",
                        }}
                      >
                        <MenuItem value="" disabled>
                          Select Destination Country
                        </MenuItem>
                        {countrymaster.map((p) => (
                          <MenuItem key={p.ID} value={p.Value}>
                            {p.Value}
                          </MenuItem>
                        ))}
                      </Select>
                      {errors.destinationCountry && (
                        <Typography variant="caption" color="error">
                          {errors.destinationCountry}
                        </Typography>
                      )}
                    </FormControl>
                  </div>

                  {/* destinationPort */}
                  <div className="col-md-4">
                    <FormControl
                      sx={{ minWidth: "100%" }}
                      error={!!errors.destinationPort}
                    >
                      <Typography variant="body2">
                        Select Destination Port
                      </Typography>
                      <Select
                        name="destinationPort"
                        value={formData.destinationPort}
                        onChange={handleChange}
                        displayEmpty
                        sx={{ backgroundColor: "white" }}
                        inputProps={{ "aria-label": "Select Destination Port" }}
                      >
                        <MenuItem value="" disabled>
                          Select Destination Port
                        </MenuItem>
                        {formPortList.length > 0 ? (
                          formPortList.map((option, index) => (
                            <MenuItem key={index} value={option.Value}>
                              {option.Value}
                            </MenuItem>
                          ))
                        ) : (
                          <MenuItem value="ACTIVE">Loading...</MenuItem>
                        )}
                      </Select>
                      {errors.destinationPort && (
                        <Typography variant="caption" color="error">
                          {errors.destinationPort}
                        </Typography>
                      )}
                    </FormControl>
                  </div>

                  {/* margin */}
                  <div className="col-md-4">
                    <div className="mt-3">
                      <Typography variant="body2">Margin (%)</Typography>
                      <TextField
                        type="text"
                        name="margin"
                        value={formData.margin}
                        onChange={handleChange}
                        sx={{ backgroundColor: "white", width: "100%" }}
                        error={!!errors.margin}
                        helperText={errors.margin}
                      />
                    </div>
                  </div>

                  {/* exportDuty */}
                  <div className="col-md-4">
                    <div className="mt-3">
                      <Typography variant="body2">Export Duty</Typography>
                      <TextField
                        type="text"
                        name="exportDuty"
                        value={formData.exportDuty}
                        onChange={handleChange}
                        sx={{ backgroundColor: "white", width: "100%" }}
                        error={!!errors.exportDuty}
                        helperText={errors.exportDuty}
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          )}
        </main>
      </div>
    </div>
  );
};
export default CountryWiseProduct;
